import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0dc4cf94"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("rect", {
  x: "-15",
  y: "81",
  width: "350",
  height: "350"
}, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", {
    width: "100%",
    height: "100%",
    viewBox: "-15 81 350 350",
    preserveAspectRatio: "xMidYMid meet",
    xmlns: "http://www.w3.org/2000/svg",
    class: _normalizeClass(["square", _ctx.outlineStyle]),
    style: _normalizeStyle({ fill: _ctx.activeColor }),
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.changeState && _ctx.changeState(...args)))
  }, [
    _hoisted_1,
    (_ctx.puzzleSlab.state === _ctx.slabState.markedByPlayer || _ctx.puzzleSlab.state === _ctx.slabState.crossedOut)
      ? (_openBlock(), _createElementBlock("path", {
          key: 0,
          style: _normalizeStyle({ fill: _ctx.markColor }),
          class: "blocked",
          d: "M310.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L160 210.7 54.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L114.7 256 9.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L160 301.3 265.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L205.3 256 310.6 150.6z"
        }, null, 4))
      : _createCommentVNode("", true)
  ], 6))
}